/*
 * @Descripttion:材料合成池材料
 * @Author: lc
 * @Date: 2021-10-25 08:33:06
 * @LastEditors: lc
 * @LastEditTime: 2021-10-29 11:41:40
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const hechengpooldata = {
    // 列表
    list(params) {
        return axios.get(api + 'hechengpooldata/list', { params: params })
    },
    //添加
    create(params) {
        return axios.post(api + 'hechengpooldata/create', qs.stringify(params))
    },
    //获取编辑信息
    detail(params) {
        return axios.get(api + 'hechengpooldata/detail', { params: params })
    },
    //修改
    edit(params) {
        return axios.post(api + 'hechengpooldata/edit', qs.stringify(params))
    },
    //删除
    remove(params) {
        return axios.post(api + 'hechengpooldata/remove', qs.stringify(params))
    },
    // 获取合成规则
    hechengrulelist(params) {
        return axios.get(api + 'hechengpooldata/hechengrulelist', { params: params })
    },
    statusrule(params) {
        return axios.post(api + 'hechengpooldata/statusrule', qs.stringify(params))
    },
    removerule(params) {
        return axios.post(api + 'hechengpooldata/removerule', qs.stringify(params))
    },
}


// 导出接口
export default hechengpooldata


